/* Bilikili Classic — theme scripts (vanilla JS, no dependencies) */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---- Mobile nav ---- */
  var nav = $('.main-nav');
  function setMenu(open) {
    if (!nav) return;
    nav.classList.toggle('open', open);
    $$('[data-menu-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (b.classList.contains('menu-btn')) b.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }
  $$('[data-menu-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { setMenu(!nav.classList.contains('open')); });
  });
  // Submenus: tap the "+" to expand on phones/tablets
  $$('.sub-toggle').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var li = b.parentNode;
      var open = !li.classList.contains('open');
      $$('.main-nav li.open').forEach(function (x) {
        if (x !== li) { x.classList.remove('open'); var t = x.querySelector('.sub-toggle'); if (t) { t.setAttribute('aria-expanded', 'false'); t.textContent = '+'; } }
      });
      li.classList.toggle('open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? '\u2212' : '+';
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  // Leaving tablet/phone size closes the panel so desktop layout is clean
  var mq = window.matchMedia('(min-width: 991px)');
  function onMq() { if (mq.matches) { setMenu(false); $$('.main-nav li.open').forEach(function (x) { x.classList.remove('open'); }); } }
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

  /* ---- Hero slider ---- */
  var hero = $('.hero');
  if (hero) {
    var slides = $$('.slide', hero);
    var dotsWrap = $('.dots', hero);
    var idx = 0, timer;
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(b);
    });
    var dots = $$('button', dotsWrap);
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('on', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('on', n === idx); });
    }
    function restart() { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 6000); }
    var prev = $('.arrow.prev', hero), next = $('.arrow.next', hero);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
    go(0); if (slides.length > 1) restart();
  }

  /* ---- Tabs (generic) ---- */
  $$('[data-tabs]').forEach(function (wrap) {
    var btns = $$('[data-tab]', wrap);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tab');
        btns.forEach(function (b) { b.classList.toggle('on', b === btn); });
        $$('.tab-panel', wrap).forEach(function (p) { p.classList.toggle('on', p.id === id); });
      });
    });
  });

  /* ---- Grid / list toggle (collection) ---- */
  $$('[data-view]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = $('#ProductGrid');
      if (!grid) return;
      var list = btn.getAttribute('data-view') === 'list';
      grid.classList.toggle('list-view', list);
      $$('[data-view]').forEach(function (b) { b.classList.toggle('on', b === btn); });
      try { localStorage.setItem('bk_view', list ? 'list' : 'grid'); } catch (e) {}
    });
  });
  try {
    if (localStorage.getItem('bk_view') === 'list') {
      var lb = $('[data-view="list"]'); if (lb) lb.click();
    }
  } catch (e) {}

  /* ---- Sort select ---- */
  var sort = $('#SortBy');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---- Product gallery ---- */
  var mainImg = $('#MainImage');
  $$('.gallery .thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = b.getAttribute('data-src');
      mainImg.removeAttribute('srcset');
      $$('.gallery .thumbs button').forEach(function (x) { x.classList.toggle('on', x === b); });
    });
  });

  /* ---- Quantity +/- ---- */
  $$('.qty').forEach(function (q) {
    var input = $('input', q);
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += b.getAttribute('data-step') === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
  });

  /* ---- Variant select: update price / stock / SKU ---- */
  var jsonEl = $('#ProductJson');
  var variantSelect = $('#VariantSelect');
  if (jsonEl && variantSelect) {
    var product = JSON.parse(jsonEl.textContent);
    var moneyFormat = (window.BK && window.BK.moneyFormat) || '${{amount}}';
    var fmt = function (cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    };
    variantSelect.addEventListener('change', function () {
      var id = parseInt(variantSelect.value, 10);
      var v = product.variants.filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      var p = $('#ProductPrice'), was = $('#ComparePrice'), stock = $('#StockLabel'), sku = $('#SkuLabel'), add = $('#AddToCart');
      if (p) p.textContent = fmt(v.price);
      if (was) {
        if (v.compare_at_price && v.compare_at_price > v.price) { was.textContent = fmt(v.compare_at_price); was.style.display = ''; }
        else { was.style.display = 'none'; }
      }
      if (stock) {
        stock.textContent = v.available ? '✔ In Stock — Ready to Ship' : '✖ Out of Stock';
        stock.classList.toggle('out', !v.available);
      }
      if (sku) sku.textContent = v.sku || '—';
      if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      var sp = $('.sticky-atc .price'), sb = $('.sticky-atc button');
      if (sp) sp.textContent = fmt(v.price);
      if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to Cart' : 'Sold Out'; }
      if (v.featured_image && mainImg) { mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset'); }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  /* ---- Sticky Add to Cart (phones) ---- */
  var sticky = $('.sticky-atc');
  var mainAdd = $('#AddToCart');
  if (sticky && mainAdd) {
    var ticking = false;
    var checkSticky = function () {
      ticking = false;
      var show = mainAdd.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('show', show);
      document.body.classList.toggle('has-sticky', show);
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); } }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
    var sBtn = sticky.querySelector('button');
    if (sBtn) sBtn.addEventListener('click', function () {
      if (mainAdd.disabled) return;
      var form = mainAdd.form;
      if (form && form.requestSubmit) form.requestSubmit(mainAdd); else mainAdd.click();
    });
  }

  /* ---- Back to top ---- */
  var top = $('.back-top');
  if (top) {
    window.addEventListener('scroll', function () { top.classList.toggle('show', window.scrollY > 500); });
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();
